import { connect } from 'react-redux';
import get from 'lodash/get';

import { fetch, ots, translations } from '@biw/contests-core';

import OnTheSpotComponent from 'components/shared/on-the-spot/on-the-spot';
import { setUserData } from 'dux/user/actions';
import { getUserName } from 'dux/user/selectors';

const redeemAndUpdateAccountBalance = ( params, dispatch ) => {
    dispatch( ots.redeem( params ) ).then( ( response ) => {
        if ( response ) {
            dispatch( setUserData( { accountBalance: { result: response.accountBalance } } ) );
        }
    } );
};

export const mapStateToProps = state => ( {
    busy: get( state, 'data.fetching.otsRedeem', false ),
    success: get( state, 'onTheSpot.success' ),
    successMessage: get( state, 'onTheSpot.successMessage' ),
    userName: getUserName( state ),
    error: fetch.selectors.getFetchingError( state, 'otsRedeem' ),
    cardPlaceholder: translations.selectors.getString( state, 'ots.form.cardPlaceholder' ),
    mediaLabel: get( state, 'goalLevel.programLevel.mediaLabel' )
} );

export const mapDispatchToProps = dispatch => ( {
    redeem: params => redeemAndUpdateAccountBalance( params, dispatch ),
    setMessage: ( messageType, message ) => dispatch( ots.setMessage( messageType, message ) ),
    setSuccess: bool => dispatch( ots.setSuccess( bool ) ),
    dismissError: () => dispatch( fetch.actions.removeFetchingError( 'otsRedeem' ) )
} );

export default connect( mapStateToProps, mapDispatchToProps )( OnTheSpotComponent );
